<div (keydown)="onkeydown($event)" >
    <app-scroll-item
        *ngFor="let item of skillsList;"
        [item]="item"
        (nextSkillOutput)="onnextSkillOutput($event)"
    ></app-scroll-item>
</div>